export default {"src":"/_next/static/media/residential12.ee84d0e2.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};